import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// axios with credentials so our session_token cookie is sent
const http = axios.create({ baseURL: API, timeout: 60000, withCredentials: true });

export { BACKEND_URL, API };

export const equipmentOptions = [
  "53' Dry Van",
  'Box Truck',
  'Reefer',
  'Flatbed',
  '26ft Straight Truck',
];

// Auth
export const processAuthSession = (sessionId) =>
  http
    .post('/auth/session', null, { headers: { 'X-Session-ID': sessionId } })
    .then((r) => r.data);
export const getMe = () => http.get('/auth/me').then((r) => r.data);
export const logout = () => http.post('/auth/logout').then((r) => r.data);

// Payments
export const getPlan = () => http.get('/payments/plan').then((r) => r.data);
export const createCheckout = (originUrl) =>
  http.post('/payments/checkout', { origin_url: originUrl }).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  http.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const cancelSubscription = () =>
  http.post('/payments/cancel').then((r) => r.data);

// Shipments
export const listShipments = () => http.get('/shipments').then((r) => r.data);
export const getQueue = () => http.get('/shipments/queue').then((r) => r.data);
export const createShipment = (body) => http.post('/shipments', body).then((r) => r.data);
export const getShipmentDetail = (id) =>
  http.get(`/shipments/${id}/detail`).then((r) => r.data);

// Carriers
export const listCarriers = () => http.get('/carriers').then((r) => r.data);
export const rankCarriers = (shipmentId) =>
  http.get('/carriers/rank', { params: { shipment_id: shipmentId } }).then((r) => r.data);

// Bookings
export const bookShipment = (shipmentId, carrierId) =>
  http.post(`/shipments/${shipmentId}/book`, { carrier_id: carrierId }).then((r) => r.data);
export const updateBookingStatus = (bookingId, status) =>
  http.patch(`/bookings/${bookingId}`, { status }).then((r) => r.data);
export const rateConfirmationUrl = (bookingId) =>
  `${API}/bookings/${bookingId}/rate-confirmation.pdf`;

// Optimizations
export const runOptimization = (body) =>
  http.post('/optimizations/run', body).then((r) => r.data);
export const getPublicPlan = (id) =>
  http.get(`/public/optimizations/${id}`).then((r) => r.data);

// Metrics / recommendations
export const getDashboardMetrics = () =>
  http.get('/metrics/dashboard').then((r) => r.data);
export const getAnalyticsMetrics = () =>
  http.get('/metrics/analytics').then((r) => r.data);
export const getRecommendation = () => http.get('/recommendation').then((r) => r.data);
export const getLoadBoard = () => http.get('/loadboard').then((r) => r.data);

// Chat / negotiation
export const listMessages = (shipmentId, carrierId) =>
  http
    .get(`/shipments/${shipmentId}/messages`, { params: { carrier_id: carrierId } })
    .then((r) => r.data);
export const sendMessage = (shipmentId, carrierId, text, rateOffer) =>
  http
    .post(
      `/shipments/${shipmentId}/messages`,
      { text, rate_offer: rateOffer || null },
      { params: { carrier_id: carrierId } }
    )
    .then((r) => r.data);

// Geocoding
export const getRouteGeo = (origin, destination, stops = []) =>
  http
    .get('/geocode/route', {
      params: {
        origin,
        destination,
        stops: stops.filter(Boolean).join(';') || undefined,
      },
    })
    .then((r) => r.data);
